import { Box } from '@mui/material';
import useCallRecording from './useCallRecording';
import AudioPlayer from './AudioPlayer';

interface CallAudioPlayerProps {
    callId: string | null;
    children: React.ReactNode;
}

/**
 * Renders an audio player with a loading and error states.
 *
 * @param {CallAudioPlayerProps} props
 * @returns {JSX.Element}
 */
const CallAudioPlayer: React.FC<CallAudioPlayerProps> = ({ callId = null, children }) => {
    const { callRecordingUrl, isLoading, errorMessage, handleLoadedData, handleCanPlay, handleAudioError } = useCallRecording(callId);

    if (!callId) return null;

    return (
        <Box
            sx={{
                px: 2,
                py: 1,
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                bgcolor: 'background.paper',
                borderTop: '1px solid',
                borderColor: 'divider',
                position: 'sticky',
                bottom: 0,
                zIndex: 1000,
                gap: 1,
            }}
            data-testid="call-audio-player"
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: 1, minHeight: 40 }}>
                <AudioPlayer
                    callRecordingUrl={callRecordingUrl}
                    errorMessage={errorMessage}
                    isLoading={isLoading}
                    handleLoadedData={handleLoadedData}
                    handleCanPlay={handleCanPlay}
                    handleAudioError={handleAudioError}
                />
            </Box>
            {children}
        </Box>
    );
};

export default CallAudioPlayer;
